// src/components/news/NewsPrevNextNav.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  classifyNewsNavHref,
  openExternalNewsHref,
} from "../../utils/newsLink";

/**
 * @param {{ id?: string|number, url?: string } | null} previousTarget - older article (Previous button)
 * @param {{ id?: string|number, url?: string } | null} nextTarget - newer article (Next button)
 */
const NewsPrevNextNav = ({ previousTarget, nextTarget }) => {
  const navigate = useNavigate();

  const go = (target) => {
    if (!target) return;
    const raw = (target.url || "").trim();

    if (raw) {
      const resolved = classifyNewsNavHref(raw);
      if (resolved.kind === "external") {
        if (/^(mailto:|tel:)/i.test(resolved.href)) {
          window.location.href = resolved.href;
        } else {
          openExternalNewsHref(resolved.href);
        }
        return;
      }
      if (resolved.kind === "internal") {
        navigate(resolved.to);
        return;
      }
    }

    const id = target.id;
    if (id != null && id !== "") {
      navigate(`/news/${id}`);
    }
  };

  const hasPrevious = Boolean(
    previousTarget &&
      ((previousTarget.url || "").trim() || previousTarget.id != null)
  );
  const hasNext = Boolean(
    nextTarget &&
      ((nextTarget.url || "").trim() || nextTarget.id != null)
  );

  if (!hasPrevious && !hasNext) return null;

  return (
    <div className="mt-8 pt-4 border-t border-gray-100 flex items-center justify-between">
      <div>
        {hasPrevious && (
          <button
            type="button"
            onClick={() => go(previousTarget)}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 bg-white text-sm font-medium text-gray-800 hover:bg-gray-100 hover:border-gray-400 transition-colors"
          >
            <span className="text-lg leading-none">←</span>
            <span>Previous</span>
          </button>
        )}
      </div>

      <div className="ml-auto">
        {hasNext && (
          <button
            type="button"
            onClick={() => go(nextTarget)}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 bg-white text-sm font-medium text-gray-800 hover:bg-gray-100 hover:border-gray-400 transition-colors"
          >
            <span>Next</span>
            <span className="text-lg leading-none">→</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default NewsPrevNextNav;
